// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"qq-z","slideIn":"rq-z"};